import { REOSC } from '../types';
export default {
  type: REOSC,
  service: 'REOSC Ecosystem',
  url: 'https://remote.reosc.io',
  port: 3000,
  auth: false,
  username: '',
  password: ''
};
